import React, { useCallback } from "react";
import clsx from "clsx";

import { IActionTeachingMaterial, IActionLessons } from "../../../../state";
import { ReactComponent as CheckIconOn } from "../../../../assets/images/ActionList/icon_check_on.svg";
import { ReactComponent as CheckIconOff } from "../../../../assets/images/ActionList/icon_check_off.svg";

import styles from "./VolumeList.module.scss";

export interface IVolumeListProps {
  activeVolumeId: number | null;
  volumeList: IActionTeachingMaterial[];
  hasAnsweredLessons: (volume: IActionTeachingMaterial) => boolean;
  handleVolumeChange: (volumeId: number) => void;
}

const VolumeList: React.FC<IVolumeListProps> = ({
  activeVolumeId,
  volumeList,
  hasAnsweredLessons,
  handleVolumeChange,
}) => {
  const allReflectionsComplete = useCallback(
    (volume: IActionTeachingMaterial) => {
      if (!volume.lessons || volume.lessons.length === 0) {
        return false;
      }
      return volume.lessons.every(
        (lesson: IActionLessons) =>
          lesson.reflection_realization_reference !== null,
      );
    },
    [],
  );

  const isSelectedVolume = (volume: IActionTeachingMaterial) => {
    return activeVolumeId === volume.id && hasAnsweredLessons(volume);
  };

  return (
    <div className={styles.wrapper}>
      {volumeList.map(volume => (
        <div
          className={styles.volume}
          onClick={() => {
            if (hasAnsweredLessons(volume)) {
              handleVolumeChange(volume.id);
            }
          }}
          key={volume.id}
        >
          <div
            className={clsx(
              styles.button,
              isSelectedVolume(volume) && styles.isSelected,
              !hasAnsweredLessons(volume) && styles.isDisabled,
            )}
          >
            <div className={styles.thumb}>
              <img className={styles.img} src={volume.image_url} alt="" />
              {allReflectionsComplete(volume) ? (
                <CheckIconOn className={styles.checkIcon} />
              ) : (
                <CheckIconOff className={styles.checkIcon} />
              )}
            </div>
            <span
              className={clsx(
                styles.label,
                !volume.lessons?.length && styles.isDisabled,
              )}
            >
              {volume.name}
            </span>
          </div>
          <div className={styles.statusList}>
            {volume.lessons?.map(lesson => {
              const isReflectionCompleted =
                lesson.reflection_realization_reference !== null;
              return (
                <div
                  className={clsx(
                    styles.statusItem,
                    isReflectionCompleted && styles.isCompleted,
                  )}
                  key={lesson.id}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VolumeList;
